import { useParams } from "react-router";
import { GetEventPageBySlug } from "@queries/GetEventPageBySlug";
import { useContent } from "@hooks/useContent";
import { Loading } from "./Loading";
import { NotFound } from "./NotFound";
import { EventPage } from "./EventPage";
import { useGlobalContext } from "@utils/GlobalContext";
import { isSlugAllowedForLocale } from "@utils/localeRestrictions";

export const EventPageResolver = () => {
  const { locale } = useGlobalContext();
  const { slug } = useParams();
  const isAllowed = isSlugAllowedForLocale(slug ?? "", locale);

  if (!isAllowed) {
    if (locale === 'en-MX') {
      // using <Navigate> or useNavigate causes an infinite redirect loop.
      window.location.replace(`/es-mx/event/${slug}`);
      return;

    } else {
      return <NotFound />;
    }
  }

  const [response] = useContent({
    query: GetEventPageBySlug,
    variables: { slug: slug },
  });

  if (response.fetching) {
    return <Loading />;
  }

  const [page] = response.data?.eventsEventPageCollection?.items ?? [];

  if (!response.data || !slug || !page) {
    return <NotFound />;
  }

  return <EventPage key={slug} page={page!} />;
};
